import type { GeoLocation } from '@bambi/api-client/schemas';
import { Button } from '@bambi/component-library/src/components/Button/Button';

interface GeolocationPickerListItemProps {
  geolocation: GeoLocation;
  onSelect: () => void;
}

export function GeolocationPickerListItem({
  geolocation,
  onSelect,
}: GeolocationPickerListItemProps) {
  const locationDetails = [
    geolocation.location.municipality,
    geolocation.location.region,
    geolocation.location.postal_code,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <div
      key={geolocation.id}
      className="flex items-center justify-between rounded-lg border border-gray-200 p-3 hover:bg-gray-50"
    >
      <div className="min-w-0 flex-1">
        <div className="truncate font-medium text-gray-900">
          {geolocation.label}
        </div>
        {locationDetails && (
          <div className="truncate text-sm text-gray-500">
            {locationDetails}
          </div>
        )}
      </div>
      <Button
        variant="primary"
        onClick={onSelect}
        className="ml-3 flex-shrink-0"
        dataTestId={`select-geolocation-${geolocation.id}`}
      >
        Select
      </Button>
    </div>
  );
}
